"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UrlBuilder {
    static build(url, params = null) {
        if (!params) {
            return url;
        }
        let resolvedUrl = url;
        Object.keys(params).forEach(key => {
            resolvedUrl = resolvedUrl.replace(`:${key}`, params[key]);
        });
        return resolvedUrl;
    }
}
exports.UrlBuilder = UrlBuilder;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-http-service/Services/UrlBuilder.ts